module.exports = __webpack_public_path__ + "img/35.e952dd05.jpg";